import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <Nav>
      <ul>
        <li>
          <StyledLink to="/" end>
            About
          </StyledLink>
        </li>
        <li>
          <StyledLink to="/resume">Resume</StyledLink>
        </li>
        <li>
          <StyledLink to="/projects">Projects</StyledLink>
        </li>
        <li>
          <StyledLink to="/contact">Contact</StyledLink>
        </li>
      </ul>
    </Nav>
  );
};

export default Navbar;

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 280px;
  right: 0;
  height: 60px;
  background-color: ${({ theme }) => theme.card};
  border-bottom: 1px solid ${({ theme }) => theme.border};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 90;

  ul {
    display: flex;
    gap: 2rem;
    list-style: none;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 105px;
    left: 0;
    width: 100%;
    justify-content: center;
    border-top: 1px solid ${({ theme }) => theme.border};
  }
`;

const StyledLink = styled(NavLink)`
  color: ${({ theme }) => theme.text};
  text-decoration: none;
  position: relative;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.accent};
  }

  &.active {
    color: ${({ theme }) => theme.accent};
  }

  &.active::after {
    content: "";
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${({ theme }) => theme.accent};
    border-radius: 3px;
  }
`;

